import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import {CommonService} from "../common.service";
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.css']
})
export class CountdownComponent implements OnInit, AfterViewInit {
  @Input() totalSeconds: number;
  @Input() remindSeconds: number;
  @Input() abilityTest: boolean;
  @Output() onTimeout = new EventEmitter<boolean>();
  @Output() onTimeReminder = new EventEmitter<boolean>();
  isHarmonyOS = false; //是否鸿蒙系统
  constructor(private commonService: CommonService) { }

  ngOnInit() {
    this.isHarmonyOS = this.commonService.isHarmonyOS();
  }

  ngAfterViewInit() {
    var totalTime = this.totalSeconds;
    var remindTime = this.remindSeconds;
    var onTimeout = this.onTimeout;
    var onTimeReminder = this.onTimeReminder;

    if(this.abilityTest){
      $("#countDown").css({
        "text-align":"right",
        "top":"0.9rem",
        "right":"0.3rem"
      });
    }

    $(document).ready(function(e) {
      var resetTime = countDown(totalTime);

      function countDown(totalTime) {
        var timer_m = document.getElementById("timer_m");
        var timer_s = document.getElementById("timer_s");
        var timer = document.getElementById("countDown");
        var timer_minute = format(Math.floor(totalTime / 60));
        var timer_second = format(Math.floor(totalTime % 60));
        timer_m.innerText = timer_minute;
        timer_s.innerText = timer_second;
        var timerBool = true;

        var intervel1 = setInterval(function () {
          if (totalTime >= -2 && timerBool) {
            totalTime--;
          }

          timer_minute = format(Math.floor(totalTime / 60));
          timer_second = format(Math.floor(totalTime % 60));

          timer_m.innerText = timer_minute > 0 ? timer_minute : '00';
          timer_s.innerText = timer_second > 0 ? timer_second : '00';

          if (totalTime <= remindTime) {
            timer.style.color = "#f96678";
          } else if (totalTime > remindTime) {
            timer.style.color = "#ffffff";
          }
          if (totalTime <= remindTime && totalTime >= remindTime - 1) {
            onTimeReminder.emit(true);
          }

          if (totalTime <= 0 && totalTime > -2) {
            onTimeout.emit(true);
          }
        }, 1000);

        return function (reset) {
          totalTime = reset;
        }
      }

      function format(number) {
        if (number < 10) {
          number = '0' + number;
        }
        return number;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/countdown/countdown.component.ts